/**
 * Для дневника создаем единый ключ, чтобы не падало несколько снеков,
 * т.к. у нас 3 разных компонента работают с журналом
 */
export const DIARY_SNACK_ID = 'diary';
